import React from "react";
import "../styles/AboutMeStyle.css"
import Collage from "../assets/AboutMeAssets/ImgCollage.png"
import Camogli from "../assets/AboutMeAssets/Camogli.jpg"

function AboutMe() {
 
  return (
    <div className="about-page">
  <div className="content-wrapper">
    <div className="about-text">
      <h1>About Me</h1>
      <p>I’m a Southern California native who grew up on the lacrosse field — playing from elementary school all the way through competing at the collegiate level in Colorado. I graduated with a bachelor’s degree in Marketing and a Minor in Psychology, which first led me into the marketing world.</p>
      <p>While working in marketing, I discovered a passion for web development and decided to fully make the jump into technology by completing a web development bootcamp. Since then, I’ve had the opportunity to work across different areas of tech — from information services, to autonomous vehicles, and now at the largest cruise corporation in the world.</p>
      <p>Outside of work, I like to keep a balance between staying active and learning new things. Every now and then I find a decent book the piques my interest, these books usually take the form of a technology/cybersecurity story. I play and practice golf nuerotically, weightlift, and occasionally play recreational lacrosse.  When I am not doing those activities, I am most likely hanging with my cats Corndog and Tortellini, or spending time with friends & family.</p>
      <img className="personal" src={Collage} alt="Collage of self"/>
      <p>Since I started at Carnival, I have had the priviledge to connect and collaborate with great people all over the globe. Moreover I have been able to travel and work with these peers face to face.
        My favorite work experience thus far was having the opportunity to travel to Italy and support our Maritime applications & teams. Meeting my Italian colleagues, experiencing their city of Genoa, and their culture was a truly gratifying experience. I hope to be back soon!</p>
      <img className="Italy" src={Camogli} alt="Italian Shores of Camogli"/>
    </div>

  </div>
</div>

  );
}

export default AboutMe;
